var exports = {
  "i": "x31de4314--2a7d81--wrapper",
  "U": "x31de4314--2a7d81--wrapper_redesign",
};

module.exports = exports;
